$(document).ready(function () {
  setTimeout(function () {
    $(".customselect_for_Hulk").show();
    var t = $(".hulkapps_option_set .hulkapps_option_name").text();
    $(".customselect_for_Hulk .hulk_option_label").text(t);
    var a = $(".hulkapps_option_value select"),
      o = $(".custom_hulkapps_option_value select");
    a.find("option").each(function () {
      var t = $(this);
      o.append(
        $("<option>", {
          value: t.val(),
          text: t.text(),
          class: t.attr("class"),
          "data-hinventory": t.data("hinventory"),
          "data-uid": t.data("uid"),
          "data-display-val": t.data("display-val"),
          "data-price": t.data("price"),
          "data-conditional-value": t.data("conditional-value"),
        })
      );
    });
  }, 3500),
    $(".custom_hulkapps_option_value select").on("change", function () {
      var t = $(this).find(":selected").data("display-val");
      console.log("Checkselect_option: " + t);
      var a = !1;
      $(".hulkapps_option_value select.hulk_po_dropdown option").each(
        function () {
          var o = $(this).data("display-val");
          console.log("hulkopt:" + o),
            o === t &&
              ((a = !0), $(this).prop("selected", !0).trigger("change"));
        }
      ),
        a
          ? console.log("Change event triggered.")
          : console.log("Not matched with any option data-display-val.");
    }),
    $(document).on(
      "change",
      ".main_prod_infovar .main_var_select .selectopt_area select",
      function () {
        var t = $(".custom_hulkapps_option_value select");
        setTimeout(function () {
          t.empty();
        }, 999),
          setTimeout(function () {
            $(".hulkapps_option_value select")
              .find("option")
              .each(function () {
                var a = $(this);
                t.append(
                  $("<option>", {
                    value: a.val(),
                    text: a.text(),
                    class: a.attr("class"),
                    "data-hinventory": a.data("hinventory"),
                    "data-uid": a.data("uid"),
                    "data-display-val": a.data("display-val"),
                    "data-price": a.data("price"),
                    "data-conditional-value": a.data("conditional-value"),
                  })
                );
              });
          }, 999);
      }
    ),
    $(
      ".custom-sample-var-select .custom_product-variant-container li.custtom-product-variant-value"
    ).click(function () {
      var t = $(this).data("value"),
        a = $(
          ".template-product-sample-wood-product .main_prod_infovar .product-variant-container"
        );
      a.find("option.product-variant-value.var-material").val(t);
      var o = new Event("change", { bubbles: !0 });
      a.find("option.product-variant-value.var-material")
        .get(0)
        .dispatchEvent(o);
    }),
    $(document).on(
      "mouseover",
      ".template-product-sample-wood-product .custtom-product-variant-value",
      function () {
        var t = $(this).attr("data-img");
        $(".product-wood-img").attr("src", t),
          $(".product-wood-type-popup").show();
      }
    ),
    $(document).on(
      "mouseover",
      ".template-product-sample-wood-product .custom-varints-itempop",
      function () {
        var t = $(this).find("img").attr("src");
        $(this)
          .closest(".template-product-sample-wood-product")
          .find(".product-wood-img")
          .attr("src", t),
          $(this)
            .closest(".template-product-sample-wood-product")
            .find(".product-wood-type-popup")
            .show();
      }
    ),
    $(document).on(
      "mouseout",
      ".template-product-sample-wood-product .custtom-product-variant-value, .template-product-sample-wood-product .custom-varints-itempop",
      function () {
        $(".product-wood-type-popup").hide();
      }
    );
});

document.addEventListener("DOMContentLoaded", function () {
  let intervalId;
  let elapsed = 0;
  const intervalTime = 100; // Interval time in milliseconds
  const timeoutTime = 10000; // Timeout time in milliseconds

  function checkElements() {
    const ulElements = document.querySelectorAll(".hulkapps_option_value");

    if (ulElements.length > 0) {
      // Define the SVG element as a string
      const svgString = `
                <svg class="your-li-class" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12 8" style="enable-background:new 0 0 12 8; width: 12px; height: 8px;" xml:space="preserve">
                    <polyline points="0,2 2,0 6,4 10,0 12,2 6,8 0,2 "></polyline>
                </svg>
            `;

      // Convert the string to an actual SVG element
      const parser = new DOMParser();
      const svgDoc = parser.parseFromString(svgString, "image/svg+xml");
      const svgElement = svgDoc.documentElement;

      // Append the SVG element to each ul element
      ulElements.forEach((ul) => {
        ul.appendChild(svgElement.cloneNode(true));
      });

      clearInterval(intervalId);
    } else {
      elapsed += intervalTime;
      if (elapsed >= timeoutTime) {
        clearInterval(intervalId);
      }
    }
  }

  intervalId = setInterval(checkElements, intervalTime);

  let intervalIds;
  function CheckCart() {
    const prodmain_addtocart = document.querySelector(
      "[data-js-product-add-to-cart]"
    );

    if (prodmain_addtocart) {
      setTimeout(() => {
        // prodmain_addtocart.classList.add("hulkapps_submit_cart");
      }, 2000);
      setTimeout(() => {
        // prodmain_addtocart.classList.add("hulkapps_submit_cart");
      }, 4000);
      clearInterval(intervalIds);

      console.log("interval cleared");
    } else {
    }
  }

  intervalIds = setInterval(CheckCart, 100);
});
